import { ActionIcon, type ActionIconProps, type PolymorphicComponentProps } from '@mantine/core';
import { IconFileTypeDocx } from '@tabler/icons-react';
import * as React from 'react';

type ActionIconButtonProps = PolymorphicComponentProps<'button', ActionIconProps>;

type ExportWordActionButtonProps = Omit<ActionIconButtonProps, 'children'> & {
  iconSize?: number;
};

const ExportWordActionButton: React.FC<ExportWordActionButtonProps> = ({ iconSize = 20, ...actionIconProps }) => {
  return (
    <ActionIcon {...actionIconProps}>
      <IconFileTypeDocx size={iconSize} />
    </ActionIcon>
  );
};

export default React.memo(ExportWordActionButton);
